module.exports = __webpack_public_path__ + "img/hom_yes.d9c3c5ce.png";